import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import AgeGate from "@/components/AgeGate";
import Layout from "@/components/Layout";
import FloatingActions from "@/components/FloatingActions";
import CookieBanner from "@/components/CookieBanner";
import AmbientMusic from "@/components/AmbientMusic";
import Portal from "@/pages/Portal";
import ClubPrive from "@/pages/ClubPrive";
import SpaNaturista from "@/pages/SpaNaturista";
import Gallery from "@/pages/Gallery";
import CalendarPage from "@/pages/Calendar";
import InfoStatuto from "@/pages/InfoStatuto";
import Contatti from "@/pages/Contatti";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

function AdminRoute() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#0B0A0C]" />;
  return user ? <AdminDashboard /> : <AdminLogin />;
}

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <BrowserRouter>
          <AgeGate>
            <Routes>
              <Route path="/" element={<Portal />} />
              <Route path="/club-prive" element={withLayout(<ClubPrive />)} />
              <Route path="/spa-naturista" element={withLayout(<SpaNaturista />)} />
              <Route path="/calendario" element={withLayout(<CalendarPage />)} />
              <Route path="/gallery" element={withLayout(<Gallery />)} />
              <Route path="/info" element={withLayout(<InfoStatuto />)} />
              <Route path="/contatti" element={withLayout(<Contatti />)} />
              <Route path="/admin" element={<AdminRoute />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <FloatingActions />
            <CookieBanner />
          </AgeGate>
          <AmbientMusic />
          <Toaster theme="dark" position="top-center" richColors />
        </BrowserRouter>
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
